/* CREU — Quick-add inline para product cards.
 * Toggle del "+" → muestra/oculta el selector de variante.
 * Click en una variante → POST /cart/add.js → abre cart drawer. */
(function() {
  if (window.__creuQuickAddInit) return;
  window.__creuQuickAddInit = true;

  function openCartDrawer() {
    var drawer = document.querySelector('cart-drawer-component');
    if (drawer && typeof drawer.open === 'function') { drawer.open(); return; }
    var trigger = document.querySelector('[data-cart-drawer-trigger], cart-icon');
    if (trigger && trigger.click) { trigger.click(); return; }
    document.dispatchEvent(new CustomEvent('cart:open'));
    document.dispatchEvent(new CustomEvent('cart:refresh'));
  }

  /* El cajón del carrito se ABRE solo, pero no se repinta: `cart-drawer.js`
   * únicamente llama a showDialog(). Quien repinta el contenido es el flujo de
   * añadir del propio tema, y este "+" no pasa por ahí — hace su POST a
   * /cart/add.js directamente. Resultado: al añadir desde una tarjeta se abría
   * el cajón con el carrito ANTERIOR (sin la pieza recién añadida, con la barra
   * de envío gratis desfasada y sin sitio donde poner el "Añadido ahora").
   * Aquí se vuelve a pedir la sección de la cabecera —que es donde vive el
   * cajón— y se sustituye el cuerpo de <cart-items-component>. El <dialog> no
   * se toca, así que el cajón no parpadea ni se cierra. */
  async function refrescarCajon() {
    var comp = document.querySelector('cart-items-component');
    var sid = comp && comp.dataset.sectionId;
    if (!comp || !sid) return;
    try {
      var html = await fetch(window.location.pathname + '?section_id=' + encodeURIComponent(sid), {
        headers: { Accept: 'text/html' },
      }).then(function (r) { return r.text(); });
      var nuevo = new DOMParser().parseFromString(html, 'text/html').querySelector('cart-items-component');
      if (nuevo) comp.innerHTML = nuevo.innerHTML;
    } catch (err) {
      // Si falla, el cajón se queda como estaba: preferible a vaciarlo.
    }
  }

  // Para otros añadidos propios (las piezas de una combinación, creu-pack-pieces.js).
  window.CreuCart = { refresh: refrescarCajon, open: openCartDrawer };

  // Regalo por compra ("Te regalamos…" del cajón, snippets/cart-drawer.liquid).
  document.addEventListener('click', async function (e) {
    var b = e.target.closest('[data-creu-gift]');
    if (!b || b.disabled) return;
    b.disabled = true;
    try {
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(b.dataset.creuGift), quantity: 1 }] }),
      });
    } catch (err) { /* el botón se reactiva abajo */ }
    await refrescarCajon();
    b.disabled = false;
  });

  function flashCartIcon() {
    var icon = document.querySelector('cart-icon, .cart-icon');
    if (!icon) return;
    icon.classList.add('is-pulse');
    setTimeout(function() { icon.classList.remove('is-pulse'); }, 600);
  }

  /* ── Etiqueta "Añadido ahora" del cajón del carrito ──────────────────────
   * El carrito solo dice QUÉ hay dentro, no qué acaba de entrar, así que la
   * línea recién añadida se marca desde aquí: guardamos el variante que se
   * acaba de mandar (o el que anuncia el evento `cart:update` cuando el añadir
   * viene de la ficha) y se destapa la etiqueta de esa fila.
   * La fila lleva `data-key="<idVariante>:<hash>"`, de ahí el split. */
  var ultimoAnadido = null;

  function pintarAnadido() {
    document.querySelectorAll('[data-creu-new]').forEach(function (el) {
      el.hidden = true;
    });
    if (!ultimoAnadido) return;
    document.querySelectorAll('.cart-drawer [data-key]').forEach(function (row) {
      if (String(row.dataset.key).split(':')[0] !== ultimoAnadido) return;
      var tag = row.querySelector('[data-creu-new]');
      if (tag) tag.hidden = false;
      if (bajarAlFinal) {
        bajarAlFinal = false;
        mostrarFinal(row);
      }
    });
  }

  /* 15-10 · Al añadir una pieza, el cajón se abre enseñando el final del
   * carrito, que es donde entra lo último añadido. Solo una vez por añadido:
   * si la clienta sube o cambia cantidades, no se la vuelve a bajar.
   * Si el cajón se abre a mano, empieza arriba como siempre. */
  var bajarAlFinal = false;

  function mostrarFinal(row) {
    var el = row.parentElement;
    while (el && el !== document.body) {
      var oy = getComputedStyle(el).overflowY;
      if ((oy === 'auto' || oy === 'scroll') && el.scrollHeight > el.clientHeight) break;
      el = el.parentElement;
    }
    var bajar = function () {
      if (el && el !== document.body) el.scrollTo({ top: el.scrollHeight, behavior: 'smooth' });
      else row.scrollIntoView({ block: 'end', behavior: 'smooth' });
    };
    requestAnimationFrame(function () { setTimeout(bajar, 120); });
  }

  document.addEventListener('cart:update', function (e) {
    var d = (e.detail && e.detail.data) || {};
    var v = d.variantId;
    // El formulario de la ficha anuncia el producto pero NO la variante: se lee
    // del propio formulario, que es lo que acaba de mandar al carrito.
    if (!v && d.source === 'product-form-component') {
      var input = document.querySelector('[data-creu-variant-input]');
      v = input && input.value;
    }
    if (v) { ultimoAnadido = String(v); bajarAlFinal = true; }
    // El cajón se repinta por secciones justo después del evento.
    setTimeout(pintarAnadido, 80);
  });

  document.addEventListener('DOMContentLoaded', function () {
    var drawer = document.querySelector('cart-drawer-component');
    if (!drawer) return;
    // Solo `childList`: si observáramos también los atributos, cambiar `hidden`
    // dispararía el observador otra vez y entraríamos en bucle.
    new MutationObserver(pintarAnadido).observe(drawer, { childList: true, subtree: true });
    var dialog = drawer.querySelector('dialog');
    if (dialog) {
      dialog.addEventListener('close', function () {
        ultimoAnadido = null;
      });
    }
  });

  async function addToCart(variantId, btn) {
    if (!variantId) return;
    ultimoAnadido = String(variantId);
    bajarAlFinal = true;
    if (btn) { btn.classList.add('is-loading'); btn.disabled = true; }
    try {
      var res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      });
      if (!res.ok) throw new Error('add_failed_' + res.status);
      await res.json();
      flashCartIcon();
      await refrescarCajon();
      openCartDrawer();
      pintarAnadido();
    } catch (err) {
      console.error('CREU quick-add error:', err);
    } finally {
      if (btn) { btn.classList.remove('is-loading'); btn.disabled = false; }
    }
  }

  // La rejilla lleva `isolation: isolate` (snippet product-grid), así que crea su
  // propio contexto de apilado y la hoja del panel —por mucho z-index que le
  // pongamos— se queda POR DEBAJO de la cabecera fija: el fondo oscuro dejaba la
  // cabecera sin atenuar. Mientras haya un panel abierto se sube la rejilla
  // entera por encima de la cabecera, y al cerrarlo vuelve a su sitio.
  function marcarAbierto() {
    var hay = !!document.querySelector('[data-creu-qa-options]:not([hidden])');
    document.documentElement.classList.toggle('creu-qa-abierto', hay);
  }

  document.addEventListener('click', function(e) {
    // Toggle "+"
    var toggle = e.target.closest('[data-creu-qa-toggle]');
    if (toggle) {
      e.preventDefault();
      var qa = toggle.closest('[data-creu-qa]');
      if (!qa) return;
      var opts = qa.querySelector('[data-creu-qa-options]');
      var isOpen = !opts.hidden;
      document.querySelectorAll('[data-creu-qa-options]').forEach(function(o) {
        if (o !== opts) o.hidden = true;
      });
      opts.hidden = isOpen;
      toggle.setAttribute('aria-expanded', String(!isOpen));
      marcarAbierto();
      return;
    }

    // Aspa de cerrar del panel (documento de cambios, bloque 5: "Cabecera
    // 'Elige tu talla' + aspa de cerrar"). Antes solo se cerraba volviendo a
    // pulsar el "+" o tocando fuera.
    var closeBtn = e.target.closest('[data-creu-qa-close]');
    if (closeBtn) {
      e.preventDefault();
      e.stopPropagation();
      var host = closeBtn.closest('[data-creu-qa]');
      if (!host) return;
      var panel = host.querySelector('[data-creu-qa-options]');
      if (panel) panel.hidden = true;
      var tg = host.querySelector('[data-creu-qa-toggle]');
      if (tg) tg.setAttribute('aria-expanded', 'false');
      marcarAbierto();
      return;
    }

    // Notificarme (valor no disponible) → abre el drawer de aviso
    var notifyBtn = e.target.closest('[data-creu-qa-notify]');
    if (notifyBtn) {
      e.preventDefault();
      e.stopPropagation();
      if (window.creuNotifyDrawer && window.creuNotifyDrawer.open) {
        window.creuNotifyDrawer.open({
          variantId: notifyBtn.dataset.variantId,
          productId: notifyBtn.dataset.productId,
          productTitle: notifyBtn.dataset.productTitle
        });
      }
      return;
    }

    // Variant button
    var variantBtn = e.target.closest('[data-creu-qa-variant]');
    if (variantBtn && !variantBtn.disabled) {
      e.preventDefault();
      addToCart(variantBtn.dataset.variantId, variantBtn);
      var opts = variantBtn.closest('[data-creu-qa-options]');
      if (opts) opts.hidden = true;
      marcarAbierto();
      return;
    }

    // Click fuera cierra cualquier picker abierto
    if (!e.target.closest('[data-creu-qa]')) {
      document.querySelectorAll('[data-creu-qa-options]').forEach(function(o) { o.hidden = true; });
      marcarAbierto();
    }
  });

  // Submit directo (productos de variante única)
  document.addEventListener('submit', function(e) {
    var form = e.target.closest('[data-creu-qa-form]');
    if (!form) return;
    e.preventDefault();
    var input = form.querySelector('input[name="id"]');
    var btn = form.querySelector('button[type="submit"]');
    addToCart(input && input.value, btn);
  });
})();
